var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-nav-item',{staticStyle:{"width":"6rem"},on:{"click":function($event){_vm.$i18n.locale = _vm.$i18n.locale === 'cn' ? 'en' : 'cn'}}},[_c('feather-icon',{style:('color:' +
            (_vm.$store.state.appConfig.layout.skin === 'dark'
                ? '#d0d2d6'
                : '#5e5873')),attrs:{"icon":"GlobeIcon","size":"21"}}),_c('p',{staticClass:"position-relative m-0 d-inline text-bold",staticStyle:{"top":"2px"},style:('color:' +
            (_vm.$store.state.appConfig.layout.skin === 'dark'
                ? '#d0d2d6'
                : '#5e5873'))},[_vm._v(" "+_vm._s(_vm.currentLocale.name)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }